import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
/**
 * React custom hook that returns the very first value passed to `initialState`,
 * even if it changes between re-renders.
 *
 * @template T
 * @param {T} initialState
 * @return {T}
 */

export function useSealedState(initialState) {
  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 1),
      sealed = _useState2[0];

  return sealed;
}